// John Eldhose 20200618
import { RestfulPost } from './Restful';

export async function unsubscribe(data) {
  const tax = await RestfulPost('unsubscribe', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return tax;
}



// WEBPACK FOOTER //
// ./src/Api/unsubscribe.js